import { render, staticRenderFns } from "./PodrAddProd.vue?vue&type=template&id=6cb53727&scoped=true&"
import script from "./PodrAddProd.vue?vue&type=script&lang=js&"
export * from "./PodrAddProd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb53727",
  null
  
)

export default component.exports